// extracted by mini-css-extract-plugin
export var image = "landing-page-product-row-module--image--pCVks";
export var row = "landing-page-product-row-module--row--JHo2Y";
export var title = "landing-page-product-row-module--title--R9Q08";